export const STANDARD_CONTRAST_RATIO = 4.5;

const HEX_MATCHER = /^#?([0-9A-F]{3}){1,2}$/i;
export function normalizePotentialHexString(val: string | undefined | null, defaultVal: string): string {
	if (!val || !HEX_MATCHER.test(val)) {
		return defaultVal;
	}
	if (val[0] !== '#') {
		return `#${val}`;
	}
	return val;
}

export function getWhiteOrBlackByContrast(hex: string): string {
	return contrastsAgainstWhite(hex) ? '#FFFFFF' : '#000000';
}

export function hexLuminance(hex: string): number {
	let val = hex;
	if (hex.indexOf('#') === 0) {
		val = val.slice(1);
	}
	// convert 3-digit val to 6-digits.
	if (val.length === 3) {
		val = val[0] + val[0] + val[1] + val[1] + val[2] + val[2];
	}
	if (val.length !== 6) {
		throw new Error('Invalid HEX color.');
	}
	// Get color components
	const r = parseInt(val.slice(0, 2), 16);
	const g = parseInt(val.slice(2, 4), 16);
	const b = parseInt(val.slice(4, 6), 16);

	return rgbLuminance(r, g, b);
}

export function rgbLuminance(r: number, g: number, b: number): number {
	return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function contrastsAgainstWhite(hex: string): boolean {
	return hexLuminance(hex) < 150;
}

export function getRandomHexColor(): string {
	// eslint-disable-next-line prefer-template
	return '#' + [
		getRandomColorComponent(),
		getRandomColorComponent(),
		getRandomColorComponent(),
	]
		.map((val) => val.toString(16).padStart(2, '0'))
		.join('');
}

function getRandomColorComponent() {
	return Math.floor(Math.random() * 256);
}
